import { FC, ReactNode, Component, Children } from 'react';
import { default as FastMarquee } from 'react-fast-marquee';

interface MarqueeProps {
	direction?: 'right' | 'left' | 'up' | 'down';
	className?: string;
	children?: ReactNode[] | Component[] | any[];
	variant?: 'primary' | 'secondary';
}

const Marquee: FC<MarqueeProps> = ({ direction = 'right', children }) => {
	return (
		<FastMarquee direction={direction} pauseOnHover gradient={false}>
			{Children.map(children, child => ({
				...child,
				props: {
					...child.props,
				},
			}))}
		</FastMarquee>
	);
};

export default Marquee;
